export default __webpack_public_path__ + "static/media/favorite-star.14af162e.svg";